<template>
    <div class="animated fadeIn conversion">
        <filters :scope="filtersScope">
        </filters>

        <operators-conversion-tabs/>

        <StatisticTable :headColumns="headColumns"
                        :footColumns="footColumns"
                        :rows="rows"
                        @isPopup="isPopup"
                        ref="statisticTable"
                        :title="`${$t('pages.operator_conversions')}`">
        </StatisticTable>
    </div>
</template>

<script>
  import Filters from '../../../../components/Filters.vue'
  import API from '../../../../api/API'
  import Storage from '../../../../api/Storage'
  import { map } from 'lodash'
/*   import moment from 'moment' */
  import getSymbolFromCurrency from 'currency-symbol-map'
  import Helper from '../../../../api/Helper'
  import TypeColor from '../../../../assets/TypeColor'
  import StatisticTable from '../../../../components/StatisticTable.vue'
  import OperatorsConversionTabs from './OperatorsConversionTabs'

export default {
    name: 'Conversion',
    components: {
      OperatorsConversionTabs,
      Filters,
      StatisticTable
    },
    data () {
      return {
        filtersScope: {
          dateFilter: true,
          offerFilter: true,
          operatorFilter: true
        },
        isLoading: false,
        Storage: Storage,
        TypeColor: TypeColor,
        Helper: Helper,
        country: null,
        headColumns: [
          {label: this.$root.$t('statistic.operator'), field: 'operator'},
          {label: this.$root.$t('statistic.processed_leads'), field: 'total'},
          {label: this.$root.$t('statistic.approved'), field: 'approved'},
          {label: this.$root.$t('statistic.canceled'), field: 'canceled'},
          {label: this.$root.$t('statistic.averageBill'), field: 'average_bill', colspan: 2},
          {label: this.$root.$t('statistic.average_x_price'), field: 'average_x_price'},
          {label: this.$root.$t('statistic.paid'), field: 'paid'}
        ],
        rows: [],
        footColumns: {},
        operators: []
      }
    },
    mounted () {
      this.calculateRows()
      this.$root.$on('filters_load_new_data', () => {
        this.calculateRows()
      })
    },
    methods: {
      isPopup (cell) {
        let el = document.createElement('textarea')
        el.value = cell.value.trim()
        el.setAttribute('readonly', '')
        el.style.position = 'absolute'
        el.style.left = '-9999px'
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
        alert('Скопирован оператор ' + el.value)
      },
      async calculateRows () {
        this.$root.$emit('data_loading')
        this.rows = []
        let oldArrCurrency = []
        let newArrCurrency = []
        this.operators = []
        await API.getOperators(Helper.getCountryList()).then(operators => {
          this.operators = operators.body
        })
        await API.getOperatorConversion().then(response => {
          let sumTotal = 0
          let count = 0
          let sumApproved = 0
          let countApproved = 0
          let sumCanceled = 0
          let countCanceled = 0
          let sumAverageBill = 0.0
          let sumAverageBillLocal = 0.0
          let sumAverageXprice = 0
          let sumAverageStartPrice = 0
          let countAverageXprice = 0
          let sumPaid = 0
          let countPaid = 0
          let statistic = {}
          let max = {
            approved: 0,
            canceled: 0,
            paid: 0,
            average_bill: 0,
            average_x_price: 0
          }
          map(response.body, (array, id) => {
            map(array, (operatorData) => {
              operatorData.average_x_price = Helper.getxstart(operatorData.average_bill_usd, operatorData.average_start_price_usd)
              statistic[id] = operatorData
              if (parseInt(max.approved) < parseInt(operatorData.approved)) {
                max.approved = operatorData.approved
              }
              if (parseInt(max.canceled) < parseInt(operatorData.canceled)) {
                max.canceled = operatorData.canceled
              }
              if (parseInt(max.paid) < parseInt(operatorData.paid)) {
                max.paid = operatorData.paid
              }
              if (parseFloat(max.average_bill_usd) < parseFloat(operatorData.average_bill_usd)) {
                max.average_bill = parseFloat(operatorData.average_bill_usd)
              }
              if (parseFloat(max.average_x_price) < parseFloat(operatorData.average_x_price)) {
                max.average_x_price = parseFloat(operatorData.average_x_price)
              }
              oldArrCurrency.push(operatorData.local_currency.split(','))
              oldArrCurrency.forEach(array => {
                array.forEach(item => {
                  newArrCurrency.push(item)
                })
              })
            })
          })
          let filterCurrency = newArrCurrency.filter((item, index) => {
            return newArrCurrency.indexOf(item) === index
          })
          map(statistic, (d) => {
            this.rows.push({
              operator: {value: `${Helper.getOperatorLogin(this.operators, d.operator_id)} ${Storage.developMode ? `(${d.operator_id})` : ''}`, popup: true},
              total: {
                value: parseInt(d.total),
                bg: true
              },
              approved: {
                value: parseInt(d.approved),
                bgg: Helper.renderSingleGist(max.approved, d.approved),
                isCollspaned: true
              },
              canceled: {
                value: parseInt(d.canceled),
                bgg: Helper.renderSingleGist(max.canceled, d.canceled),
                isCollspaned: true
              },
              averageBill: {
                value: '$ ' + d.average_bill_usd.toFixed(2),
                  // bgg: Helper.renderGistPart(100, Helper.averageBill(d.average_bill_usd, false, true)),
                isCollspaned: true
              },
              averageBillLocal: {
                value: d.local_currency.split(',').length === 1 ? `${d.average_bill_local.toFixed(0)} ${getSymbolFromCurrency(d.local_currency)}` : '-'
                  // bgg: Helper.renderGistPart(100, Helper.averageBill(d.average_bill_local, false, true), true)
              },
              average_x_price: {
                value: d.average_x_price,
                bgg: Helper.renderSingleGist(max.average_x_price, d.average_x_price)
              },
              paid: {
                value: parseInt(d.paid),
                bgg: Helper.renderSingleGist(max.paid, d.paid)
              }/* ,
              time_recalld: {
                value: `${d.time_recall ? `${moment(d.time_recall).format('mm:ss')}` : ''}`
              },
              time_success_calld: {
                value: `${d.time_success_call ? `${moment(d.time_success_call).format('mm:ss')}` : ''}`
              } */
            })
            sumTotal = sumTotal + d.total
            count = count + 1
            if (d.approved > 0) {
              sumApproved = sumApproved + d.approved
              countApproved = countApproved + 1
              if (d.average_bill_usd > 0) {
                sumAverageBill += parseFloat(d.average_bill_usd) * d.approved
              }
              sumAverageBillLocal += parseFloat(d.average_bill_local) * d.approved
            }
            if (d.canceled > 0) {
              sumCanceled = sumCanceled + d.canceled
              countCanceled = countCanceled + 1
            }
            if (d.average_start_price_usd > 0) {
              sumAverageStartPrice = parseFloat(sumAverageStartPrice) + parseFloat(d.average_start_price_usd)
            }
            if (d.average_x_price > 0) {
              sumAverageXprice = parseFloat(sumAverageXprice) + parseFloat(d.average_x_price)
              countAverageXprice = countAverageXprice + 1
            }
            if (d.paid > 0) {
              sumPaid = sumPaid + d.paid
              countPaid = countPaid + 1
            }
          })
          this.footColumns = {
            label: {
              value: this.$root.$t('statistic.in_total')
            },
            total: {
              value: `${sumTotal} (${Helper.average(sumTotal, count)})`,
              graph: true
            },
            approved: {
              value: `${sumApproved} (${Helper.average(sumApproved, countApproved)})`,
              graph: true
            },
            canceled: {
              value: `${sumCanceled} (${Helper.average(sumCanceled, countCanceled)})`,
              graph: true
            },
            averageBill: {
              value: filterCurrency.length === 1 ? `${Helper.localAverageBill(Helper.average(sumAverageBillLocal, sumApproved))}` : '-',
              colspan: 2,
              graph: true
            },
            average_x_price: {
              value: `${Helper.getxstart(sumAverageBill, sumAverageStartPrice)}`,
              graph: true
            },
            paid: {
              value: `${sumPaid} (${Helper.average(sumPaid, countPaid)})`,
              graph: true
            }/* ,
            time_recall: {
              value: `${moment(Helper.average(sumTimeR, countTimeR)).format('mm:ss')}`,
              graph: true
            },
            time_success_call: {
              value: `${moment(Helper.average(sumTimeS, countTimeS)).format('mm:ss')}`,
              graph: true
            } */
          }
          this.$root.$emit('data_loaded')
        }).catch(response => {
          this.$root.$emit('data_loaded')
          this.$notify({
            type: 'danger',
            title: this.$root.$t('verbs.error'),
            text: !response.body.message ? response.body : response.body.message,
            animationType: 'velocity'
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Conversion.vue?63c2ebb2